import { connect } from 'react-redux';
import PropTypes from 'prop-types';

function Rbac({
  roles,
  fallback,
  app: {
    profile: { role, siteRole },
  },
  children,
}) {
  return [role, siteRole].some((r) => roles.includes(r)) ? children : fallback;
}

const mapStateToProps = ({ app }) => ({
  app,
});

Rbac.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  fallback: PropTypes.node,
  app: PropTypes.shape({
    profile: PropTypes.shape({
      role: PropTypes.string,
      siteRole: PropTypes.string,
      tenant: PropTypes.string,
      originalTenant: PropTypes.string,
    }),
  }).isRequired,
};

Rbac.defaultProps = {
  fallback: null,
};

export default connect(mapStateToProps)(Rbac);
